export default "__VITE_ASSET__CjC1PNBm__"